import { useEffect, useRef, useState } from "react";
import { carparkLog } from "../../static-models/MemberModuleData";
import { useAppSelector } from "../../redux/hooks";
import useGetCarparkLogs from "../../Hooks/carpark/useGetCarparkLogs";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
} from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import useButtonStyles from "../../styles/useButtonStyles";
import theme from "../../theme";
import { getHashURL } from "../../util/SearchandFIlters/searchAndFilter";
import { operatorConstants } from "../../util/SearchandFIlters/Constants";
import InfiniteTable from "../Table/InfiniteScroll/InfiniteTable";
import SearchInput from "../../Shared/Components/SearchInput/SearchInput";
import { SearchToolTip, DateConstants } from "../../constants/AppConstants";
import { getEncodedValue } from "../forms/utility";

const CarParkLogs = () => {
  const buttonStyles = useButtonStyles();
  const carParkLogs = useAppSelector(
    (state: any) => state.persistReducers.getMemberList.carParkLogs
  );
  const memberDetails = useAppSelector(
    (state: any) => state.persistReducers.getMemberList?.membersList
  );
  const [carParkData, setCarParkData] = useState([]);
  const [isInitialApiCall, setIsInitialApiCall] = useState(true);
  const [filterActive, setFilterActive] = useState(false);
  const {
    fetchCarParkLogs,
    loading,
    lastKey,
    carParkLogData,
    transactionTypeList,
    totalCount,
    setLastKey,
    setCarParkLogData,
  } = useGetCarparkLogs();
  useEffect(() => {
    setCarParkData(carParkLogData);
  }, [carParkLogData]);
  const handleClose = () => {
    setOpenFilter(false);
  };
  // integration for filters
  const [openFilter, setOpenFilter] = useState(false);

  const [filterState, setFilterState] = useState({
    action: "",
    transactionDate: "",
  });

  const resetFilterState = () => {
    setFilterState({
      action: "",
      transactionDate: "",
    });
    onReset();
    setFilterActive(false);
    setFilterStates([]);
  };
  const [filterStates, setFilterStates] = useState<any>([]);

  const getAllFields = (fieldValue: any, value: any, operator?: any) => {
    const existingObject = filterStates.find(
      (obj: any) => obj.fieldValue === fieldValue
    );

    if (!existingObject) {
      setFilterStates((prev: any) => [
        ...prev,
        { fieldValue: fieldValue, value: value, operator: operator },
      ]);
    } else {
      setFilterStates((prev: any) =>
        prev.map((obj: any) =>
          obj.fieldValue === fieldValue
            ? { ...obj, value: value, operator: operator }
            : obj
        )
      );
    }
  };
  const onReset = () => {
    setCarParkLogData([]);
    setCarParkData([]);
    setLastKey(null);
    setIsInitialApiCall(true);
  };
  const searchInputRef = useRef<HTMLInputElement>();

  const bindSearchAndFilter = (canHaveExistingData?: boolean) => {
    const hashValue = {
      field: "email",
      value: memberDetails.email,
    };
    const value = searchInputRef.current
      ? getEncodedValue(searchInputRef.current?.value)
      : "";
    const searchParam = value !== "" ? [value] : [];
    const params = {
      hashData: hashValue,
      searchData: searchParam,
      filterData: filterStates,
    };
    const url = getHashURL(params);

    fetchCarParkLogs(url, canHaveExistingData);
    setIsInitialApiCall(false);
    return url;
  };

  useEffect(() => {
    if (isInitialApiCall) bindSearchAndFilter();
  }, [isInitialApiCall]);

  const handleSearch = () => {
    onReset();
  };
  const handleApply = () => {
    onReset();

    setOpenFilter(false);
    filterStates.length && setFilterActive(true);
  };

  const handleTransactionChange = (event: SelectChangeEvent) => {
    getAllFields(
      "transaction_type",
      (event.target as HTMLSelectElement).value,
      operatorConstants.equal
    );

    setFilterState((prev) => ({
      ...prev,
      action: event.target.value,
    }));
  };

  return (
    <>
      <Grid display={"flex"} justifyContent={"center"} px={4} py={3}>
        <Dialog onClose={handleClose} open={openFilter} sx={{ ml: "60vw" }}>
          <Grid sx={{ width: "484px", py: 4, px: 2 }}>
            <DialogTitle
              display={"flex"}
              justifyContent={"space-between"}
              borderBottom={theme.border?.smallGrey}
            >
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.primary,
                  fontSize: theme.font?.fontSize.large,
                  fontWeight: theme.font?.fontWeight.thicker,
                }}
              >
                Filter
              </Typography>
              {/* <IconButton onClick={() => setOpenFilter(false)}> */}
              <IconButton
                onClick={() => {
                  setOpenFilter(false);
                }}
              >
                <CloseOutlinedIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent sx={{ borderBottom: theme.border?.smallGrey }}>
              <Grid>
                <Grid borderBottom={theme.border?.smallGrey} mt={5}>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.medium,
                      fontWeight: theme.font?.fontWeight.thick,
                    }}
                  >
                    Action
                  </Typography>
                  <Grid
                    gap={2}
                    mt={2}
                    display={"flex"}
                    sx={{
                      width: "80%",
                    }}
                  >
                    <FormControl
                      fullWidth
                      size="small"
                      sx={{
                        with: "100%",
                      }}
                    >
                      <Select
                        id=""
                        value={filterState.action}
                        onChange={handleTransactionChange}
                      >
                        {transactionTypeList.map((name: any) => (
                          <MenuItem value={name}>{name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid borderBottom={theme.border?.smallGrey} mt={5}>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.medium,
                      fontWeight: theme.font?.fontWeight.thick,
                    }}
                  >
                    Date
                  </Typography>
                  <Grid display={"flex"} gap={2} mt={2}>
                    <TextField
                      sx={{
                        display: "flex",
                        width: "80%",
                      }}
                      type="date"
                      size="small"
                      placeholder="Transaction Date"
                      value={filterState.transactionDate}
                      onChange={(e) => {
                        getAllFields(
                          "date",
                          new Date(e.target.value).getTime(),
                          operatorConstants.equal
                        );
                        setFilterState((prev) => ({
                          ...prev,
                          transactionDate: e.target.value,
                        }));
                      }}
                      InputProps={{
                        inputProps: {
                          max: DateConstants.maxDate,
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions sx={{ pr: 4, gap: 1, pt: 3 }}>
              <Button
                sx={{ ...buttonStyles.outlinedSecondary }}
                onClick={() => {
                  resetFilterState();
                }}
              >
                Reset
              </Button>
              <Button
                sx={{ ...buttonStyles.containedSecondary }}
                onClick={handleApply}
              >
                Apply
              </Button>
            </DialogActions>
          </Grid>
        </Dialog>
        <Grid display={"flex"} gap={3} width={"100%"} justifyContent={"end"}>
          <SearchInput
            HelpTip={SearchToolTip.CarParkLog}
            onCallBack={handleSearch}
            ref={searchInputRef}
          />
          <Button
            variant="text"
            startIcon={
              filterActive ? (
                <FilterAltIcon sx={{ color: theme.color?.secondary }} />
              ) : (
                <FilterAltOutlinedIcon />
              )
            }
            sx={{ color: theme.color?.newFilterGrey }}
            onClick={() => {
              setOpenFilter(true);
            }}
          >
            Filter
          </Button>
        </Grid>
      </Grid>
      <InfiniteTable
        header={carparkLog.columns}
        contentItems={carParkData}
        hasMoreRecords={lastKey != null}
        fetchMoreData={() => {
          bindSearchAndFilter(true);
        }}
        isInitialLoading={carParkData.length === 0 && loading}
        totalRecords={totalCount}
      />
    </>
  );
};

export default CarParkLogs;
